// src/features/reservations/components/StateChip.tsx
//
// The primary `ReservationState.state` chip, shared by Llegadas de hoy,
// Reservas and the reservation detail header. Colour/icon come from the
// registry, the label from i18n — never invented at the call site.
import React from 'react';
import { Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslate } from 'react-admin';
import { getReservationStateMeta } from '@/design/registry/reservationStateRegistry';
import { resolveColor, resolveSoftBg } from '@/design/registry/colors';
import type { ReservationPrimaryState } from '@/types/reservationState';

export interface StateChipProps {
  state: ReservationPrimaryState;
  size?: 'small' | 'medium';
}

export const StateChip: React.FC<StateChipProps> = ({ state, size = 'small' }) => {
  const translate = useTranslate();
  const theme = useTheme();
  const meta = getReservationStateMeta(state);

  return (
    <Chip
      icon={<meta.Icon sx={{ fontSize: 15 }} />}
      label={translate(meta.labelKey)}
      size={size}
      sx={{
        fontWeight: 600,
        color: resolveColor(meta.color, theme),
        backgroundColor: resolveSoftBg(meta.color, theme),
        '& .MuiChip-icon': { color: resolveColor(meta.color, theme) },
      }}
    />
  );
};

export default StateChip;
